import React, { useRef, useState } from "react";
import { IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import * as style from "./ValueStreams.module.scss";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import ConfirmModal from "../../Components/Modals/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { Divider } from "cprime-foundational-components";
import Typography from "../../Components/Common/CprimeText";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme?.palette?.common?.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme?.palette?.common?.black,
    color: theme?.palette?.common?.white,
    fontSize: theme?.typography?.pxToRem(12),
    maxWidth: 300,
    border: "1px solid #dadde9",
    padding: theme?.spacing(1),
  },
}));
const Card: React.FC<{
  group: any;
  name: any;
  description: any;
  id: any;
  expandedCards: any;
  handleDelete: any;
}> = ({ name, description, id, group, expandedCards, handleDelete }) => {
  const scssClass = style as any;
  const ref = useRef<HTMLDivElement | null>(null);
  // const [isOverflow, setIsOverflow] = useState(false);
  const [modalMessage, setModalMessage] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleClick = (id: Number) => {
    navigate(`/edit-value-streams/${id}`);
  };

  // useEffect(() => {
  //   if (ref?.current) {
  //     setIsOverflow(ref?.current?.scrollWidth > ref?.current?.offsetWidth);
  //   }
  // }, []);
  const isDeleteDisabled = group?.applications?.length > 0;

  return (
    <div className={scssClass.container} style={{ boxShadow: "none" }}>
      <div className={scssClass.featureSection}>
        <div
          className="ml-4 space-y-1"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className={scssClass.featureItem}>
            <div
              className={scssClass.featureRow}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <div className={scssClass.gridrow}>
                <div className={scssClass.gridcol}>
                  <Typography
                    ref={ref}
                    className={scssClass.groupName}
                    noWrap
                    sx={{
                      fontSize: "20px !important",
                      lineHeight: "28px !important",
                      fontWeight: "600 !important",
                      color: "#000000 !important",
                    }}
                  >
                    {name ? name : ""}
                  </Typography>
                </div>
              </div>
              <div className={scssClass.gridcol2}>
                <div
                  style={{
                    display: !group?.hasOwnProperty("action") ? "none" : "",
                  }}
                  className={scssClass.gridcol1}
                >
                  <div style={{ display: "flex" }}>
                    <IconButton
                      disabled={false}
                      style={{
                        margin: "0",
                        padding: "0",
                        color: "#000",
                        display: "flex",
                      }}
                      onClick={() => handleClick(id)}
                    >
                      <EditIcon />
                    </IconButton>

                    <IconButton
                      disabled={isDeleteDisabled}
                      data-testid="delete"
                      style={{
                        margin: "0",
                        padding: "0",
                        color: isDeleteDisabled ? "" : "#000",
                      }}
                      onClick={() => setIsModalOpen(true)}
                    >
                      <DeleteOutlineIcon />
                    </IconButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ boxShadow: "none", paddingBottom: "32px" }}>
        <div className={scssClass.header}>
          <Typography
            className={scssClass.groupDescription}
            style={{
              fontSize: "14px",
              padding: "4px 0px",
            }}
          >
            {description ? description : ""}
          </Typography>
        </div>
      </div>

      {expandedCards[id] && (
        <div className={scssClass.featureSection} style={{ marginTop: "0" }}>
          <div
            className="ml-4 space-y-1"
            style={{
              display: "flex",
              flexDirection: "column",
              // padding: "0 18px",
            }}
          >
            {group?.applications?.map((feature: any, index: number) => (
              <div className={scssClass.featureItem} key={index}>
                <div
                  className={scssClass.featureRow}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    opacity: feature?.disabled ? 0.5 : 1,
                    padding: "5px 0px 5px 0px",
                  }}
                >
                  <div className={scssClass.gridrow}>
                    <div className={scssClass.gridcol}>
                      <span
                        style={{
                          fontSize: "14px",
                          lineHeight: "18px",
                          fontWeight: "400",
                          color: "#000",
                          // marginLeft: "8px",
                        }}
                      >
                        {feature?.name}
                      </span>
                    </div>
                    {/* Info icon with popover */}
                  </div>
                  <div className={scssClass.gridcol2}>
                    <CustomTooltip
                      title={
                        feature?.mapping_description === null
                          ? "No description available"
                          : feature?.mapping_description
                      }
                    >
                      <IconButton
                        size="medium"
                        sx={{
                          "&.MuiSvgIcon-root": {
                            fill: "#000",
                            fontSize: "16px",
                          },
                        }}
                      >
                        <InfoOutlinedIcon
                          fontSize="medium"
                          sx={{
                            "&.MuiSvgIcon-root": {
                              fill: "#000",
                              fontSize: "16px",
                            },
                          }}
                        />
                      </IconButton>
                    </CustomTooltip>
                  </div>
                </div>
                {group?.applications?.length - 1 !==
                  group?.applications?.indexOf(feature) && (
                  <Divider
                    variant={"middle"}
                    sx={{ borderColor: "#d9d9d9", margin: "12px 10px" }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      <ConfirmModal
        value={modalMessage}
        limitmessage={""}
        modalMessage={""}
        isOpen={isModalOpen}
        headLabel={"Are you sure you want to delete this value stream"}
        deleteModal={true}
        handleClose={() => {
          setIsModalOpen(false);
          setModalMessage("");
        }}
        handleConfirm={() => handleDelete(id, setIsModalOpen)}
        cancelButtonLabel={"Cancel"}
        confirmButtonLabel={"Delete"}
        confirmButtonStyle="danger"
        handleTextFeild={(value: string) => {
          setModalMessage((prev) => value);
        }}
      />
    </div>
  );
};

export default Card;
